import { createContext } from "react";

import { type MachineGroup } from "@/schemas/machine-group";
import { type ProductionGroup } from "@/schemas/production-group";

export interface ProductionContextProps {
	machineGroups: MachineGroup[];
	currentMachineGroup: MachineGroup | null;
	productionGroups: ProductionGroup[];
	currentProductionGroup: ProductionGroup | null;
	setMachineGroups: (machineGroups: MachineGroup[]) => void;
	setProductionGroups: (productionGroups: ProductionGroup[]) => void;
	setCurrentMachineGroup: (machineGroup: MachineGroup | null) => void;
	setCurrentProductionGroup: (productionGroup: ProductionGroup | null) => void;
}

export const initialProps: ProductionContextProps = {
	machineGroups: [],
	currentMachineGroup: null,
	productionGroups: [],
	currentProductionGroup: null,
	setMachineGroups: () => {},
	setProductionGroups: () => {},
	setCurrentMachineGroup: () => {},
	setCurrentProductionGroup: () => {},
};

export const ProductionContext = createContext<ProductionContextProps>(initialProps);
